import React from 'react';
import { StyledOpener } from './styled';

export default function Cloaser({ onClick, isOpen = false }) {
  return (
    <StyledOpener
      type="button"
      onClick={onClick}
      data-open={isOpen ? 'true' : 'false'}
      aria-label={isOpen ? 'Close menu' : 'Open menu'}
      aria-expanded={isOpen}
    >
      <span />
      <span />
      <span />
    </StyledOpener>
  );
}
